import PropTypes from 'prop-types';
import React from 'react';
import CopyrightComponent from './CopyrightComponent';

var AuthorPriceViews = function AuthorPriceViews(_ref) {
  var authorUsername = _ref.authorUsername,
      authorLink = _ref.authorLink,
      dateInfo = _ref.dateInfo,
      licence = _ref.licence,
      licenceCode = _ref.licenceCode,
      licenceTooltip = _ref.licenceTooltip,
      views = _ref.views;
  return /*#__PURE__*/React.createElement("div", {
    className: "dashboard-card__author-price-views"
  }, /*#__PURE__*/React.createElement("span", {
    className: "dashboard-card__author-price-views__author"
  }, /*#__PURE__*/React.createElement("a", {
    href: authorLink
  }, authorUsername)), /*#__PURE__*/React.createElement("span", {
    className: "dashboard-card__title-date-copyright__date-copyright__date"
  }, dateInfo), views && /*#__PURE__*/React.createElement("span", {
    className: "dashboard-card__author-price-views__views"
  }, "Views: ", views), (licence || licenceCode) && /*#__PURE__*/React.createElement(CopyrightComponent, {
    licence: licence,
    licenceCode: licenceCode,
    licenceTooltip: licenceTooltip
  }));
};

AuthorPriceViews.displayName = "AuthorPriceViews";
AuthorPriceViews.propTypes = {
  authorUsername: PropTypes.string.isRequired,
  authorLink: PropTypes.string.isRequired,
  dateInfo: PropTypes.string.isRequired,
  licence: PropTypes.string,
  licenceCode: PropTypes.string,
  views: PropTypes.number,
  licenceTooltip: PropTypes.string
};
export default AuthorPriceViews;